<template>
  <el-form :model="form" ref="form" label-position="top">
    <el-row>
      <el-col :span='12'>
        <el-form-item label="exchange名称" prop='exchange'>
          <el-input v-model='form.exchange'></el-input>
        </el-form-item>
      </el-col>
      <el-col :span='12'>
        <el-form-item label="routingkey名称" prop='routingkey'>
          <el-input v-model='form.routingkey'></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发送确认超时时间" prop="confirmtimeout">
          <el-input-number v-model="form.confirmtimeout"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="form.threshold"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否自动创建队列" prop="autocreate">
          <el-switch
            v-model="form.autocreate"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="是否开启发送确认模式" prop="confirmselect">
          <el-switch
            v-model="form.confirmselect"
            active-text="开"
            inactive-text="关">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>

  import rApi from "@/api/senior/seniorconf";

  let datafault = {
  };
  export default {
    components: { rApi },
    props: {
      uuid:""
    },
    data() {
      return {
        form:{
          confirmtimeout:60000,
          threshold:50000,
          autocreate:"",
          confirmselect:"",
          exchange:'',
          routingkey:''
        }
      };
    },
    mounted() {
      if(this.uuid){
        rApi.getPdSenior(this.uuid).then(resp=>{
          var _form = JSON.parse(resp.data);
          this.form.confirmtimeout = _form.confirmtimeout?_form.confirmtimeout:this.form.confirmtimeout;
          this.form.threshold = _form.threshold?_form.threshold:this.form.threshold;
          this.form.autocreate = _form.autocreate||_form.autocreate===false?_form.autocreate:this.form.autocreate;
          this.form.confirmselect = _form.confirmselect||_form.confirmselect===false?_form.confirmselect:this.form.confirmselect;
          this.form.exchange=  _form.exchange||_form.exchange===false?_form.exchange:this.form.exchange;
          this.form.routingkey=  _form.routingkey||_form.routingkey===false?_form.routingkey:this.form.routingkey;
        });
      }
    },
    methods: {
      save(){
        if(this.uuid){
          rApi.doSaveForPdSenior(this.uuid,JSON.stringify(this.form)).then(()=>this.$message.success("操作成功！"));
        }
        return this.form;
      }
    }
  };
</script>
<style scoped>
</style>